export default __webpack_public_path__ + "static/media/bmpIcon.3cf55e37.svg";